<template>
    <div class="wrapper">
        <!-- <van-loading color="#fff" /> -->
        <template v-for="(item, index) in 9">
            <img v-show="index + 1 == Index" :src="require('@/assets/images/loading/' + (index + 1) + '.png')" alt="">
        </template>
        <van-circle class="circle" v-model="percent" :rate="100" size="2rem" :color="gradientColor" />
        <!-- <div class="txt">加载中 {{ percent }}</div> -->
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            percent: "0%",
            count: 0,
            timer: null,
            timer1: null,
            timer2: null,
            i: 0,
            Index: 0,
            gradientColor: {
                '0%': '#ffffff',
                '100%': '#ffde00',
            }
        };
    },
    watch: {},
    computed: {},
    methods: {
        preload() {
            let imgs = [
                require('@/assets/images/popup-bg.png'),
                require('@/assets/images/list-title-w.png'),
                require('@/assets/images/list-title-a.png'),
                require('@/assets/images/list-title-n.png'),
                require('@/assets/images/list-title-s.png'),
                require('@/assets/images/logo+sologen.png'),
            ];
            for (var i = 1; i < 261; i++) {
                imgs.push(require("@/assets/images/spread/" + i + ".jpg"));
            }
            for (let img of imgs) {
                let image = new Image();
                image.src = img;
                image.onload = () => {
                    this.count++;
                    // 计算图片加载的百分数，绑定到percent变量
                    let percentNum = Math.floor(
                        (this.count / imgs.length) * 100
                    );
                    this.percent = Math.floor(percentNum)
                    if (percentNum == 100) {
                        clearTimeout(this.timer1);
                        this.timer2 = setTimeout(() => {
                            this.$router.replace({ path: "/index" });
                        }, 1000);
                    }
                };
            }
        },
    },
    created() {


    },
    mounted() {
        let Index = this.Index
        setTimeout(() => {
            this.timer = setInterval(() => {
                Index++;
                if (Index == 10) {
                    Index = 1
                }
                this.Index = Index
            }, 50)
        }, 1000)
        this.preload();
        this.timer1 = setTimeout(() => {
            clearTimeout(this.timer2);
            this.$router.replace({ path: "/index" });
        }, 10000);
    },
    destroyed() {
        clearInterval(this.timer);
    },
};
</script>
<style scoped>
.wrapper {
    width: 100%;
    height: 100vh;
    background-image: url(../../assets/images/loading/loading.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    overflow: hidden;
}

.circle {
    margin-left: 2.75rem;
    margin-top: 6.2rem;
}

img {
    position: absolute;
    top: 0;
    width: 100%;
}

.txt {
    font-size: 0.28rem;
    font-family: PingFangSC;
    font-weight: 600;
    text-align: center;
    color: #fff;
    margin: 8rem auto;
}
</style>